import {
	drivingLicenceClassAUOptions,
	drivingLicenceClassSGOptions,
	getGoPlatformOptions,
	popcarPlatformsOptions,
} from "src/utils/options";
import { getGoConfig, popCarConfig } from "./flagConfig";

type CarparkAddressLookup =
	typeof getGoConfig.carparkAddress | typeof popCarConfig.carparkAddress;

type PlatformOptionsType =
	typeof popcarPlatformsOptions | typeof getGoPlatformOptions;

type DrivingLicenceClassOptionsType =
	typeof drivingLicenceClassSGOptions | typeof drivingLicenceClassAUOptions;

export interface BrandConfig {
	brandName: "Getgo" | "Popcar";
	platformName: "Popcar FMS" | "GetGo FMS";
	logoUrl?: string;
	logoMarkUrl?: string;
	favicon?: string;
	carparkAddress: CarparkAddressLookup;
	loginLogo: { img: string; style?: string };
	sidebarLogo: { img: string; style?: string };
	platformOptions: PlatformOptionsType;
	isDamageValidationEnabled: boolean;
	drivingLicenceClassOptions: DrivingLicenceClassOptionsType;
	currencySymbol: string;
	timezone: string;
	defaultCountryCode: string;
	mobileValidation: { pattern: RegExp; message: string };
	isEVEnabled: boolean;
	carparkAddressPlaceholder: string;
	isCarparkCoordinatesEnabled: boolean;
}
const brands: Record<string, BrandConfig> = {
	Getgo: {
		brandName: "Getgo",
		platformName: "GetGo FMS",
		...getGoConfig,
	},
	Popcar: {
		brandName: "Popcar",
		platformName: "Popcar FMS",
		...popCarConfig,
	},
};
const brandName = import.meta.env.FMS_BRAND as string;
export const brand: BrandConfig = brands[brandName] ?? brands["Getgo"];
export function applyBrand(): void {
	if (typeof document === "undefined") return; // SSR guard
	document.title = brand.platformName;
	// Favicon
	let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
	if (!link) {
		link = document.createElement("link");
		link.rel = "icon";
		document.head.appendChild(link);
	}
	link.type = "image/png";
	link.href = brand.favicon;
	// data-brand on <html> for CSS scoping: [data-brand="Popcar"] .foo { ... }
	document.documentElement.dataset.brand = brand.brandName;
	// Inject only the active brand's token stylesheet
	const styleLink = document.createElement("link");
	styleLink.rel = "stylesheet";
	styleLink.href =
		brand.brandName === "Popcar"
			? new URL("./popcar/tokens.css", import.meta.url).href
			: new URL("./getgo/tokens.css", import.meta.url).href;
	document.head.prepend(styleLink);
}
